import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { createUseStyles } from "react-jss";
import { Link } from "react-router-dom";
import { exceptionHandler } from "shared-components";
import { API } from "shared-components/src/api/api";

import {
  LoadErrorComponent,
  NoDataComponent
} from "../../atoms/InfoComponent/index.stories";
import { ComponentWrapper } from "../Layout/ComponentWrapper";

const useStyles = createUseStyles((theme: any) => {
  return {
    tableWrapper: {
      padding: "24px",
      background: "white",
      height: "-webkit-fill-available",
      "& th": {
        fontWeight: "bold !important",
        borderBottom: `1px solid ${theme.gray4} !important`,
        color: theme.gray9
      },
      "& td": {
        color: theme.gray8,
        borderBottom: `1px solid ${theme.gray4} !important`,
        "& a": {
          color: theme.blue6
        }
      },
      "& .ant-pagination-item-link": {
        borderRadius: 35
      },
      "& li": {
        borderRadius: 35
      }
    },
    container: {
      margin: 20
    },
    loaderWrapper: {
      width: "100%",
      height: "80vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  };
});

interface Team {
  key: string;
  id: string;
  team_name: string;
  owner_name: string;
  email: string;
  invitation_code: string;
}

const TeamList = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [teamlist, setTeamList] = useState([] as Team[]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true as boolean);

  useEffect(() => {
    getTeamLists();
  }, []);

  const getTeamLists = async () => {
    setLoading(true);
    try {
      const response = await API.get(`admin/teams`);
      if (response && response.data) {
        setTeamList(
          response.data.map((data: any) => {
            return {
              key: data.id,
              id: data.id,
              team_name: data.team.name,
              owner_name: data.user.name,
              email: data.user.email,
              invitation_code: data.team.invitation_code
            };
          })
        );
      }
      setLoading(false);
    } catch (error) {
      exceptionHandler(error, t);
      setError(true);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: t("Team name"),
      dataIndex: "team_name",
      key: "team_name"
    },
    {
      title: t("Team code"),
      dataIndex: "invitation_code",
      key: "invitation_code"
    },

    {
      title: t("Owner name"),
      dataIndex: "owner_name",
      key: "owner_name"
    },

    {
      title: t("Action"),
      key: "action",
      render: (text: string, data: Team) => {
        return <Link to={`teams/edit/${data.id}`}>{t("Edit")}</Link>;
      }
    }
  ];

  return (
    <ComponentWrapper title="Teams" add="/teams/add">
      <div className={classes.container}>
        {error ? (
          <LoadErrorComponent />
        ) : (
          <div className={classes.tableWrapper}>
            {!loading && teamlist.length === 0 ? (
              <NoDataComponent />
            ) : (
              <Table
                loading={loading}
                dataSource={teamlist}
                columns={columns}
              />
            )}
          </div>
        )}
      </div>
    </ComponentWrapper>
  );
};

export { TeamList };
